var DropzonePhase = /* @__PURE__ */ ((DropzonePhase2) => {
  DropzonePhase2["Empty"] = "empty";
  DropzonePhase2["Loading"] = "loading";
  DropzonePhase2["SelectedFiles"] = "selected";
  DropzonePhase2["ConfirmedFiles"] = "confirmed";
  DropzonePhase2["Invalid"] = "error";
  DropzonePhase2["Valid"] = "success";
  return DropzonePhase2;
})(DropzonePhase || {});
export {
  DropzonePhase
};
//# sourceMappingURL=dropzone.enum.es.js.map
